const navToggle = () => {
    const toggleField = document.querySelector('#nav-primary-toggle');
  
    toggleField.addEventListener('change', event => {
      document.body.classList.toggle('nav-toggled', event.target.checked);
    });
  };
  
  export default navToggle;
  